module.exports = __webpack_public_path__ + "static/img/ticad_banner@2x.77a17dfc.png";